import { datadogRum } from '@datadog/browser-rum';

export const initDatadogMinimal = () => {
  console.log('Initializing Datadog RUM (minimal setup)...');

  try {
    // Check if already initialized
    try {
      if (datadogRum.getInternalContext && datadogRum.getInternalContext()) {
        console.log('Datadog already initialized');
        return;
      }
    } catch (e) {
      // Continue with initialization
    }

    const getSessionReplaySampleRate = () => {
      const env = process.env.REACT_APP_ENV;
      if (env === 'uat') {
        return 40;
      }
      if (env === 'prod') {
        return 50;
      }
      return 40; // Default for other environments
    };

    datadogRum.init({
      applicationId: '39da6fa4-88ca-42ff-b8b8-80db9905920c',
      clientToken: 'pub35f1c144784a8ea599e7758b5110a947',
      site: 'datadoghq.eu' as const,
      service: 'web-react-online-seed-recommendation',
      env: process.env.REACT_APP_ENV,
      version: '1.0.0',
      sessionSampleRate: 100,
      sessionReplaySampleRate: getSessionReplaySampleRate(),
    });

    console.log('Datadog RUM initialized with minimal config');

    return true;
  } catch (error) {
    console.error('Failed to initialize Datadog:', error);
    return false;
  }
};
